// extracted by mini-css-extract-plugin
export default {"Language":"Language_Language__Fy-r+","swing-in":"Language_swing-in__slCqn"};